import React from "react";
import { UserAggregate } from "@norma-bi/bi-api";

type UnhydratedAuthContext = {
  isHydrated: false;
  isAuthenticated: undefined;
  user: undefined;
};
type UnauthenticatedAuthContext = {
  isHydrated: true;
  isAuthenticated: false;
  user: undefined;
};
type AuthenticatedAuthContext = {
  isHydrated: true;
  isAuthenticated: true;
  user: UserAggregate;
};

export type AuthContext =
  | AuthenticatedAuthContext
  | UnauthenticatedAuthContext
  | UnhydratedAuthContext;

export const authContext = React.createContext<AuthContext>({
  isHydrated: false,
  isAuthenticated: undefined,
  user: undefined,
});
